import { render, staticRenderFns } from "./WidgetPaymentProcess.vue?vue&type=template&id=5ff1a84e"
import script from "./WidgetPaymentProcess.vue?vue&type=script&lang=js"
export * from "./WidgetPaymentProcess.vue?vue&type=script&lang=js"
import style0 from "./WidgetPaymentProcess.vue?vue&type=style&index=0&id=5ff1a84e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports